import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";

const getInvoicePaymentItems = {
    namespaced: true,
    state: {
        invoicePaymentItems: [],
        areInvoicePaymentsFetching: false,
    },
    mutations: {
        SUCCESS_GET_INVOICE_PAYMENT_ITEMS(state, response) {
            state.invoicePaymentItems = response.data.data;
            state.areInvoicePaymentsFetching = false;
        },
        FAILURE_GET_INVOICE_PAYMENT_ITEMS(state, error) {
            state.areInvoicePaymentsFetching = false;
            console.log(error)
        }
    },
    actions: {
        getInvoicePaymentItemsRequest({dispatch, state}) {
            const urlParams = new URLSearchParams(window.location.search);
            let requestUrl = `/invoices/invoicePaymentItems/${urlParams.get("id")}`;
            let promise = sendRequest("get", config.baseURLApi + requestUrl, {});
            state.areInvoicePaymentsFetching = true;
            promise.then(function (result) {
                if(result[0] === "success") {
                    dispatch("successGetInvoicePaymentItems", result[1]);
                } else {
                    dispatch("failureGetInvoicePaymentItems", result[1]);
                }
            })
        },
        successGetInvoicePaymentItems: function({ commit }, response) {
            commit("SUCCESS_GET_INVOICE_PAYMENT_ITEMS", response);
        },
        failureGetInvoicePaymentItems: function({ commit }, response) {
            commit("FAILURE_GET_INVOICE_PAYMENT_ITEMS", response);
        }
    }
}

export default getInvoicePaymentItems;